"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const trans_1 = require("@common/tsutils/trans");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const MapSideBarPanel_vue_1 = __importDefault(require("./MapSideBarPanel.vue"));
const ToolItem_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Tools/ToolItem.vue"));
const CompositorWidget_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Tools/CompositorWidget.vue"));
const DimensionToolBar_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Tools/DimensionToolBar.vue"));
class ToolDimensionItem {
    constructor(obj) {
        this.label = obj.label || '';
        this.hook = obj.hook || '';
        this.icon = obj.icon || '';
        this.size = obj.size || '';
        this.hasCheck = obj.hasCheck;
        this.enabled = obj.enabled;
        this.isSecondaryIncluded = obj.isSecondaryIncluded;
        this.sub = obj.sub || '';
    }
}
class ToolDimension {
    constructor(obj) {
        this.label = obj.label || '';
        this.hook = obj.hook || '';
        this.tools = obj.tools || new Array();
    }
}
let MapSideBarPanelTools = class MapSideBarPanelTools extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.activeDimension = 'advanced';
        this.toolDimensions = new Array(new ToolDimension({
            label: (0, trans_1.trans)('results_view_map.tools_list.taxo'),
            hook: 'taxonomicals',
            tools: [
                new ToolDimensionItem({
                    label: (0, trans_1.trans)('results_view_map.tools_list.cooc'),
                    hook: 'cooc',
                    icon: 'BlobsIcon',
                    size: '40',
                    hasCheck: true,
                    enabled: true,
                    isSecondaryIncluded: false,
                    sub: this.mainProject.project_type[0] + ' - ' + this.mainProject.area_name
                }),
            ]
        }), new ToolDimension({
            label: (0, trans_1.trans)('results_view_map.tools_list.metrics'),
            hook: 'metrics',
            tools: [
                new ToolDimensionItem({
                    label: (0, trans_1.trans)('results_view_map.tools_list.heatmap'),
                    hook: 'heatmap',
                    icon: 'HeatmapIcon',
                    size: '40',
                    hasCheck: true,
                    enabled: true,
                    isSecondaryIncluded: false,
                    sub: this.mainProject.project_type[0] + ' - ' + this.mainProject.area_name + ' + ' + (0, trans_1.trans)('results_view_map.categories.' + this.metric.category)
                }),
                new ToolDimensionItem({
                    label: (0, trans_1.trans)('results_view_map.tools_list.bp'),
                    hook: 'mbp',
                    icon: 'BoxPlotIcon',
                    size: '30',
                    hasCheck: true,
                    enabled: true,
                    isSecondaryIncluded: false,
                    sub: this.mainProject.project_type[0] + ' - ' + this.mainProject.area_name + ' + ' + this.metric.name
                }),
            ]
        }), new ToolDimension({
            label: (0, trans_1.trans)('results_view_map.tools_list.advanced'),
            hook: 'advanced',
            tools: [
                new ToolDimensionItem({
                    label: (0, trans_1.trans)('results_view_map.tools_list.distro'),
                    hook: 'ratedistro',
                    icon: 'WavesIcon',
                    size: '30',
                    hasCheck: false,
                    enabled: (this.mainProject.project_type === 'rate') ? true : false,
                    isSecondaryIncluded: false,
                    sub: this.mainProject.project_type[0] + ' - ' + this.mainProject.area_name
                }),
            ]
        }));
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    changeSecondaryInclusion(dim, tool) {
        this.toolDimensions[dim].tools[tool].isSecondaryIncluded = !this.toolDimensions[dim].tools[tool].isSecondaryIncluded;
        /*        const DimIx = this.toolDimensions.findIndex((d:ToolDimension) => d === dim)
               if(DimIx !== -1) {
                    const ToolIx = this.toolDimensions[DimIx].findIndex((t: ToolDimensionItem) => t === tool)
        
                    if(ToolIx !== -1) {
                        this.toolDimensions[DimIx].tools[ToolIx].isSecondaryIncluded = !this.toolDimensions[DimIx].tools[ToolIx].isSecondaryIncluded
                    }
               } */
    }
    changeDimension(d) {
        this.activeDimension = d;
    }
    launchTool(tool) {
        if (tool.hook === 'ratedistro') {
            const url = '/results/distro?projectId=' + this.mainProject.project_id + '&areaId=' + this.mainProject.area_id;
            window.open(url, "_blank");
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'single' })
], MapSideBarPanelTools.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], MapSideBarPanelTools.prototype, "mainProjectsList", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], MapSideBarPanelTools.prototype, "secondaryProjectsList", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], MapSideBarPanelTools.prototype, "compositableProjects", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelTools.prototype, "mainProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelTools.prototype, "secondaryProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelTools.prototype, "metric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MapSideBarPanelTools.prototype, "theme", void 0);
MapSideBarPanelTools = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Separator: bmk_ui_framework_1.Separator,
            HeatmapIcon: bmk_ui_framework_1.HeatmapIcon,
            BoxPlotIcon: bmk_ui_framework_1.BoxPlotIcon,
            WavesIcon: bmk_ui_framework_1.WavesIcon,
            BlobsIcon: bmk_ui_framework_1.BlobsIcon,
            MapSideBarPanel: MapSideBarPanel_vue_1.default,
            DimensionToolBar: DimensionToolBar_vue_1.default,
            ToolItem: ToolItem_vue_1.default,
            CheckBox: bmk_ui_framework_1.CheckBox,
            Button: bmk_ui_framework_1.Button,
            CompositorWidget: CompositorWidget_vue_1.default
        },
    })
], MapSideBarPanelTools);
exports.default = MapSideBarPanelTools;
